<app-loader *ngIf="isDisabled"></app-loader>
<form name="RegularizationForm" (ngSubmit)="Validate(RegularizationForm)" #RegularizationForm="ngForm" class="pb-2">
    <div class="card">
        <div class="card-header">
            <div class="card-title">
                Regularization Request
            </div>
        </div>
        <div class="card-body">
            <!-- <div id="photoContainer" class="photo-container emp-prof-current bg-gradient">
            <div class="container-data">
                <div class="container-data-1">
                    <div>
                         <img class="user-photo" src="https://preview.keenthemes.com/metronic-v4/theme/assets/pages/media/profile/profile_user.jpg"  >
                    </div>
                    <div class="container-data-2">
                        <h3  class="emp-name ">Matin Masuri{{AttendanceDetail.FUllName}}</h3>
                        <div >#0001{{AttendanceDetail.EmpCode}}</div>
                    </div>
                </div>
            </div>
        </div> -->
            <div class="row">
                <div class="col-md-3" style="position: fixed;position: sticky;">
                    <ngb-datepicker #dp class="datepicker" name="date"
                        (dateSelect)="RegularizationDateSelect($event)" />
                </div>
                <div class="col mx-4">
                    <div *ngFor="let Regularization of Regularization.RegularizationAttendanceDetails; let i = index">
                        <div class="details details-shift bg-white">
                            <div class="details-shift-header">
                                <div class="details-shift-header-content">
                                    <div class="day text-center">
                                        <h2 class="text-center text-secondary">{{ (Regularization.date ?
                                            Regularization.date.year + '-' + Regularization.date.month + '-' +
                                            Regularization.date.day : null) | date:'d' }}</h2>
                                        <span class="text-5 text-secondary text-regular"> {{
                                            Regularization.dayInWords
                                            }} </span>

                                    </div>
                                    <div class="attendance-shift ellipsis p-2">
                                        <div style="display: flex; ">
                                            <h4 class="text-overflow" title="General"> General(GEN)</h4>
                                        </div>
                                        <span class="text-5 text-secondary text-regular" title="Shift : 09:00 to 18:00">
                                            Shift : 09:00 to 18:00 </span>
                                    </div>
                                    <div class="attendance-scheme ellipsis">
                                        <div style="display: flex;justify-content: end;">
                                            <h4 class="text-overflow"></h4><button type="button" (click)="CardDelete(i)"
                                                class="btntrash"><i class="bi bi-trash-fill"></i></button>
                                        </div>
                                    </div>

                                </div>
                                <div class="row detail-shift-body p-1">
                                    <div class="col-md-1 d-flex pt-5">
                                        <input class="form-check-input" [(ngModel)]="Regularization.IsIn"
                                            name="ChkIn{{i}}" value="In" type="checkbox">
                                        <h4 class="text-overflow mx-2 pt-1">In</h4>
                                    </div>
                                    <div class="col-md-auto pe-0">
                                        <ngb-timepicker name="InTime{{i}}" type="time"
                                            [(ngModel)]="Regularization.InTime" #InTime="ngModel"
                                            [disabled]="!Regularization.IsIn" required
                                            [ngModelOptions]="{standalone: true}"
                                            (change)="timeFormate($event,'InTime',i)" required></ngb-timepicker>
                                        <div class="invalid-feedback">
                                            Please Enter IN Time!
                                        </div>
                                    </div>
                                    <div class="col-md-auto ps-0" style="align-content: center;"><i
                                            class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                            [ngbTooltip]="tooltip.Message24hr"></i></div>
                                    <div class="col-md Reasontext">
                                        <input type="text" class="form-control" name="ReasonIn{{i}}"
                                            [(ngModel)]="Regularization.InReason" #ReasonIn="ngModel"
                                            placeholder="Ex. Forgot To Punch" [disabled]="!Regularization.IsIn"
                                            required>
                                        <div class="invalid-feedback">
                                            Please Enter IN Reason!
                                        </div>

                                    </div>
                                </div>
                                <div class="row detail-shift-body p-1">
                                    <div class="col-md-1 d-flex pt-5">
                                        <input class="form-check-input" type="checkbox"
                                            [(ngModel)]="Regularization.IsOut" name="ChkOut{{i}}" value="Out">
                                        <h4 class="text-overflow mx-2 pt-1">Out</h4>
                                    </div>
                                    <div class="col-md-auto pe-0">
                                        <ngb-timepicker name="OutTime{{i}}" [(ngModel)]="Regularization.OutTime"
                                            #OutTime="ngModel" [disabled]="!Regularization.IsOut" required #DP1
                                            [ngModelOptions]="{standalone: true}"
                                            (change)="timeFormate($event,'OutTime',i)" required></ngb-timepicker>
                                        <div class="invalid-feedback">
                                            Please Enter OUT Time!
                                        </div>
                                    </div>
                                    <div class="col-md-auto ps-0" style="align-content: center;"><i
                                            class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                            [ngbTooltip]="tooltip.Message24hr"></i></div>
                                    <div class="col-md Reasontext">
                                        <input type="text" name="ReasonOut{{i}}" [(ngModel)]="Regularization.OutReason"
                                            #ReasonOut="ngModel" placeholder="Ex. Forgot To Punch"
                                            [disabled]="!Regularization.IsOut" required class="form-control">
                                        <div class="invalid-feedback">
                                            Please Enter OUT Reason!
                                        </div>
                                    </div>
                                    <div class="col-md-2 d-flex align-self-center">
                                        <input class="form-check-input" type="checkbox"
                                            [(ngModel)]="Regularization.IsRotationalShift" name="ChkRotational{{i}}"
                                            value="IsRotationalShift" [disabled]="!Regularization.IsOut">
                                        <h4 class="text-overflow mx-2 pt-1">Rotational Shift</h4>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                    (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>

                <!-- <button *ngIf="this.common.PageRight.IsAdd" type="submit" class="btn btn-primary"
                    [disabled]="isDisabled"><i class="bi bi-pass" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Submit':'Loading...'}}</button> -->

                <button type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-pass"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Submit':'Loading...'}}</button>
            </div>
        </div>
    </div>
</form>